import { render, staticRenderFns } from "./PasswordForgotten.vue?vue&type=template&id=0f6cb4ba&scoped=true"
import script from "./PasswordForgotten.vue?vue&type=script&setup=true&lang=js"
export * from "./PasswordForgotten.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PasswordForgotten.vue?vue&type=style&index=0&id=0f6cb4ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6cb4ba",
  null
  
)

export default component.exports